import styled from 'styled-components';

export const StyledContainer = styled.div`
  width: 100%;
  max-width: 87.5rem;
  padding: 1.5rem 2.5rem;
`;
